import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "spinner"]
  
  connect() {
    // Listen for form submission
    this.element.addEventListener('turbo:submit-start', this.showLoading.bind(this))
    this.element.addEventListener('turbo:submit-end', this.hideLoading.bind(this))
  }
  
  showLoading() {
    // Hide the icons
    if (this.hasIconTarget) {
      this.iconTarget.style.display = 'none'
    }
    
    // Show the spinner
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.style.display = 'inline-block'
    }
    
    // Optionally disable the button
    const button = this.element.querySelector('button[type="submit"]')
    if (button) {
      button.disabled = true
    }
  }
  
  hideLoading() {
    // Show the icons
    if (this.hasIconTarget) {
      this.iconTarget.style.display = 'inline-block'
    }
    
    // Hide the spinner
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.style.display = 'none'
    }
    
    // Re-enable the button
    const button = this.element.querySelector('button[type="submit"]')
    if (button) {
      button.disabled = false
    }
  }
}
